import { FRAGMENT_COLORS } from '../constants/sequence';
import type { ThemePalette } from '../types';

export type SequenceAppearanceMode = 'color' | 'mono-white' | 'mono-black';

export function resolveSequenceAppearanceMode(options: {
  viewerEnabled?: boolean;
  paper?: 'white' | 'black';
  exportMonochrome?: boolean;
}): SequenceAppearanceMode {
  if (options.exportMonochrome) return 'mono-white';
  if (options.viewerEnabled) {
    return options.paper === 'black' ? 'mono-black' : 'mono-white';
  }
  return 'color';
}

export function resolveSequencePalette(
  mode: SequenceAppearanceMode,
  base: ThemePalette,
): ThemePalette {
  if (mode === 'color') return base;
  if (mode === 'mono-white') {
    return {
      ...base,
      canvasBg: '#ffffff',
      gridLine: '#e5e7eb',
      nodeBody: '#ffffff',
      nodeStroke: '#111827',
      nodeText: '#111827',
      nodeSubText: '#4b5563',
      nodeShadow: 'rgba(0,0,0,0.08)',
      edgeDefault: '#111827',
      edgeSelected: '#111827',
      edgeArrow: '#111827',
    };
  }
  return {
    ...base,
    canvasBg: '#000000',
    gridLine: '#1f2937',
    nodeBody: '#000000',
    nodeStroke: '#f9fafb',
    nodeText: '#f9fafb',
    nodeSubText: '#d1d5db',
    nodeShadow: 'rgba(255,255,255,0.08)',
    edgeDefault: '#f9fafb',
    edgeSelected: '#f9fafb',
    edgeArrow: '#f9fafb',
  };
}

export function resolveParticipantColor(
  color: string,
  mode: SequenceAppearanceMode,
  palette: ThemePalette,
): string {
  if (mode === 'color') return color;
  return palette.nodeBody;
}

export function resolveMessageColor(
  color: string | undefined,
  mode: SequenceAppearanceMode,
  palette: ThemePalette,
): string | undefined {
  if (mode === 'color') return color;
  return palette.edgeDefault;
}

export function resolveFragmentAccentColor(
  type: string,
  mode: SequenceAppearanceMode,
  palette: ThemePalette,
): string {
  if (mode === 'color') return FRAGMENT_COLORS[type] ?? '#6366f1';
  return palette.edgeDefault;
}

export function formatSequenceMessageLabel(label: string, sequenceNumber?: number): string {
  if (sequenceNumber == null) return label;
  const trimmed = label.trim();
  return trimmed ? `${sequenceNumber}. ${trimmed}` : `${sequenceNumber}.`;
}
